import { Box, Divider, Group, Menu, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import SvgIconRaw from "~/components/SvgIconRaw";
import { useOrgs } from "~/hooks/useOrgs";

import RoundIconButton from "../Button/RoundIconButton";

const DEMO_ORGS = [
  { idString: "Demo_USA", displayName: "Demo USA", scenario: "DemoUSA" },
  { idString: "Demo_Aus", displayName: "Demo Australia", scenario: "DemoAus" },
];

const SwitchDemo = () => {
  const { t } = useTranslation("common");
  const { currentOrg } = useOrgs();

  const handleOrgSelect = async (scenario: string) => {
    // Set the new scenario in localStorage
    localStorage.setItem("MEQ-Mock-scenario", scenario);

    // Load the scenario and call its login method to populate localStorage
    const scenarioModule = await import(`../../mocks/scenarios/${scenario}.ts`);
    const { login } = await scenarioModule.getScenario();
    login();

    // Reload to apply the new scenario
    window.location.reload();
  };

  return (
    <Menu position="bottom-start" offset={8} shadow="md">
      <Menu.Target>
        <Group
          gap={4}
          wrap="nowrap"
          style={{ cursor: "pointer" }}
          data-testid="demo-org-switcher"
        >
          <Text size="xs" fw={600} data-testid="current-org-name">
            {currentOrg?.displayName}
          </Text>
          <Box data-testid="demo-org-switcher-dropdown">
            <RoundIconButton size={16}>
              <SvgIconRaw
                name="ChevronDown"
                size={24}
                color="var(--mantine-color-text-tertiary)"
              />
            </RoundIconButton>
          </Box>
        </Group>
      </Menu.Target>
      <Menu.Dropdown miw={200}>
        <Stack px={16} py={4} gap={0}>
          <Text size="sm" fw={600}>
            {t("nav.selectDemoOrganization")}
          </Text>
        </Stack>
        <Divider />
        {DEMO_ORGS.map((org) => {
          const isCurrent = org.idString === currentOrg?.idString;
          return (
            <Menu.Item
              key={`demo_org_${org.idString}`}
              onClick={() => handleOrgSelect(org.scenario)}
              disabled={isCurrent}
              aria-disabled={isCurrent || undefined}
              data-testid={`demo-org-option-${org.idString}`}
              leftSection={
                isCurrent ? (
                  <SvgIconRaw name="Check" size={20} data-testid="CheckIcon" />
                ) : (
                  <Box w={20} />
                )
              }
            >
              <Text size="xs" fw={600}>
                {org.displayName}
              </Text>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};

export default SwitchDemo;
